import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Issue12026() {
  const handleDownload1 = () => {
    window.open(
      "assets/2026/issue1/1. Malsawmsanga et al - Development-Oriented Forest Governance - The Economic Implications of the FCAA (2023) in Mizoram.pdf",
      "_blank",
    );
  };
  const handleDownload2 = () => {
    window.open(
      "assets/2026/issue1/2. Vanrammawia, K & Zolianzuali - An Assessment of Ginger Marketing in Mizoram under the Bana Kaih (Hand Holding) Scheme, 2024.pdf",
      "_blank",
    );
  };
  const handleDownload3 = () => {
    window.open(
      "assets/2026/issue1/3. Lalkroschhuanga, K --- Level of Socio-Economic Development and Public Employment Opportunities in Mizoram edited.pdf",
      "_blank",
    );
  };
  const handleDownload4 = () => {
    window.open(
      "assets/2026/issue1/4. Laldampuii, R - Stigma, Survival, and Support Coping Mechanisms among Female Sex Workers Living with HIV in Aizawl, Mizoram e.pdf",
      "_blank",
    );
  };
  const handleDownload5 = () => {
    window.open(
      "assets/2026/issue1/5. Hnamte, MS Dawngliana - Women Entrepreneurship in India Edited.pdf",
      "_blank",
    );
  };
  const handleDownload6 = () => {
    window.open(
      "assets/2026/issue1/6. Sangthuamluaia, C - Determinants of Public Expenditure on Social Services in Mizoram.pdf",
      "_blank",
    );
  };
  const handleDownload7 = () => {
    window.open("assets/2026/issue1/7. Statistics At a Glance.pdf", "_blank");
  };
  return (
    <div className="min-h-screen flex flex-col sm:mb-0 md:mb-48 mb-48">
      <Header />
       <meta
        name="description"
        content="Development-Oriented Forest Governance - The Economic Implications of the FCAA (2023) in Mizoram"
      />
      <meta name="description" content="An Assessment of Ginger Marketing in Mizoram under the Bana Kaih (Hand Holding) Scheme, 2024" />
      <meta
        name="description"
        content="Level of Socio-Economic Development and Public Employment Opportunities in Mizoram edited"
      />
      <meta
        name="description"
        content="Stigma, Survival, and Support Coping Mechanisms among Female Sex Workers Living with HIV in Aizawl, Mizoram e"
      />
      <meta
        name="description"
        content="Women Entrepreneurship in India Edited"
      />
      <meta
        name="description"
        content="Determinants of Public Expenditure on Social Services in Mizoram"
      />
      <meta name="description" content="Statistics At a Glance" />
      <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Vol. IX, Issue 1 June 2026 </div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Development-Oriented Forest Governance: The Economic
                  Implications of the FCAA (2023) in Mizoram
                </div>
                <div className="text-sm text-green-600">
                  Margaret Z Khiangte, Malsawmsanga & Zoramkhuma
                </div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  An Assessment of Ginger Marketing in Mizoram under the Bana
                  Kaih (Hand Holding) Scheme, 2024: Evidence from the 2025
                  Marketing Season
                </div>
                <div className="text-sm text-green-600">
                  K. Varammawia & Zolianzuali
                </div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Level of Socio-Economic Development and Public Employment
                  Opportunities in Mizoram
                </div>
                <div className="text-sm text-green-600">K. Lalkroschhuanga</div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Stigma, Survival, and Support Coping Mechanisms among Female Sex Workers Living with HIV in Aizawl, Mizoram
                </div>
                <div className="text-sm text-green-600">R. Laldampuii</div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Women Entrepreneurship in India: An Instrument of Inclusive
                  Economic Growth and Sustainable Development
                </div>
                <div className="text-sm text-green-600">
                  M.S. Dawngliana Hnamte
                </div>
              </button>
              <button className="text-left" onClick={handleDownload6}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Determinants of Public Expenditures on Social Services in
                  Mizoram
                </div>
                <div className="text-sm text-green-600">C. Sangthuamluaia</div>
              </button>
              <button className="text-left" onClick={handleDownload7}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  STATISTICS AT A GLANCE
                </div>
                <div className="text-sm text-green-600">
                  Estimated Meat Production in Mizoram
                </div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
